import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { IOrganization } from '@shared/models/organization';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { selectAuthUser } from '@state/auth/auth.selectors';
import {
  selectOrganizationUrlSlug,
  selectOrganizationDetails,
} from '@state/organization/organization.selectors';

@UntilDestroy()
@Component({
  selector: 'app-shared-organization-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class OrganizationTopbarComponent implements OnInit, OnChanges {
  @Input() marginTop: string | undefined | null;
  @Input() margin: string | undefined | null;

  protected isFromCurrentUser = false;
  protected shareModalOpen = false;

  protected urlSlug: string | null | undefined;
  protected userOrgSlug: string | null | undefined = null;
  protected organization: IOrganization | undefined;

  protected computedStyle: { [key: string]: string } = {};

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.store
      .select(selectAuthUser)
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        this.userOrgSlug = user?.organization?.shortName?.toLowerCase();
        this.checkIfFromCurrentUser();
      });

    this.store
      .select(selectOrganizationUrlSlug)
      .pipe(untilDestroyed(this))
      .subscribe((urlSlug) => {
        this.urlSlug = urlSlug?.toLowerCase();
        this.checkIfFromCurrentUser();
      });

    this.store
      .select(selectOrganizationDetails)
      .pipe(untilDestroyed(this))
      .subscribe((organization) => {
        this.organization = organization;
      });
  }

  ngOnChanges(): void {
    this.computedStyle = {};
    if (this.marginTop) {
      this.computedStyle['margin-top'] = this.marginTop;
    }
    if (this.margin) {
      this.computedStyle['margin'] = this.margin;
    }
  }

  private checkIfFromCurrentUser(): void {
    this.isFromCurrentUser =
      !!this.urlSlug &&
      !!this.userOrgSlug &&
      this.urlSlug.toLowerCase() === this.userOrgSlug.toLocaleLowerCase();
  }
}
